import React from 'react';

import { StyleSheet } from 'react-native';
import type { StyleProp, ViewStyle } from 'react-native';

import { Box } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

import { DELIVERY_PROGRESS_COLOR } from './constants';

const barMargin = 45;

interface ProgressBarProps {
  percentComplete: number;
  styles?: StyleProp<ViewStyle>;
  whiteVariant?: boolean;
}

const ProgressBar: React.FC<React.PropsWithChildren<ProgressBarProps>> = ({
  percentComplete = 0,
  styles = {},
  whiteVariant,
}) => {
  return (
    <Box style={[progressBarStyles.line, styles]}>
      <Box style={[progressBarStyles.completeSegment, { width: `${percentComplete}%` }]} />
      <Box
        style={[
          progressBarStyles.remainingSegment,
          whiteVariant && progressBarStyles.remainingSegmentWhite,
          { width: `${100 - percentComplete}%` },
        ]}
      />
    </Box>
  );
};

const progressBarStyles = StyleSheet.create({
  completeSegment: {
    backgroundColor: DELIVERY_PROGRESS_COLOR,
  },
  line: {
    flexDirection: 'row',
    height: spacing.$1,
    left: barMargin,
    position: 'absolute',
    right: barMargin,
    top: barMargin,
  },
  remainingSegment: {
    backgroundColor: primitive.$greyFive,
  },
  remainingSegmentWhite: {
    backgroundColor: primitive.$white,
  },
});

export default ProgressBar;
